// UKOI — повноекранний hero-слайдер: автопрокрутка / стрілки / крапки / свайп / клавіатура.
(function () {
  function initSlider(root) {
    if (root.__ukoiSlider) return;
    root.__ukoiSlider = true;

    var track = root.querySelector('.uslider__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.uslide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.uslider__dot'));
    var n = slides.length;
    if (!track || n === 0) return;

    var i = 0;
    var timer = null;
    var interval = (parseFloat(root.dataset.autoplay) || 0) * 1000;

    function render() {
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function go(idx) { i = (idx % n + n) % n; render(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }

    function start() { stop(); if (interval > 0 && n > 1) timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    var nextBtn = root.querySelector('.uslider__arrow--next');
    var prevBtn = root.querySelector('.uslider__arrow--prev');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });

    // пауза при наведенні / фокусі
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // перетягування мишею І пальцем (Pointer Events) — трек тягнеться за курсором/пальцем
    var dragging = false, moved = false, startX = 0, deltaX = 0, w = 1;
    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return; // тільки ліва кнопка
      dragging = true; moved = false; startX = e.clientX; deltaX = 0; w = root.clientWidth || 1;
      root.classList.add('is-dragging'); stop();
    }
    function onMove(e) {
      if (!dragging) return;
      deltaX = e.clientX - startX;
      if (Math.abs(deltaX) > 4) moved = true;
      track.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + deltaX + 'px))';
    }
    function onUp() {
      if (!dragging) return;
      dragging = false; root.classList.remove('is-dragging');
      var thresh = Math.min(120, w * 0.15);
      if (Math.abs(deltaX) > thresh) { deltaX < 0 ? next() : prev(); } else { render(); }
      start();
    }
    track.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    // після перетягування — гасимо клік, щоб не спрацювала навігація по посиланню
    root.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    // клавіатура (коли слайдер у фокусі)
    root.setAttribute('tabindex', root.getAttribute('tabindex') || '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); restart(); }
      else if (e.key === 'ArrowLeft') { prev(); restart(); }
    });

    // пауза, коли вкладка неактивна
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    render();
    start();
  }

  function initAll() { document.querySelectorAll('.uslider').forEach(initSlider); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Shopify theme editor: пере-ініт при (пере)завантаженні секції
  document.addEventListener('shopify:section:load', initAll);
})();
